import { api } from '@/services';

export default {
  async fetchPrefaturamento({ commit }, payload) {
    const { codigoProcesso, codigoFilial, codigoDi, codigoInvoice } = payload;
    const response = await api.get(`/processo/conferencia/processo/${codigoProcesso}/filial/${codigoFilial}/codigoDI/${codigoDi}/invoice/${codigoInvoice}/conferencia-pre-faturamento`);
    commit('SET_PRE_FATURAMENTO_COMPARATIVO_PRODUTO_DI', response.data.comparativoProdutoDI);
    commit('SET_PRE_FATURAMENTO_PRODUTOS_PROCESSO', response.data.produtosProcesso);
    commit('SET_PRE_FATURAMENTO_FINANCEIRO_PAGAR', response.data.financeiroPagar);
    commit('SET_PRE_FATURAMENTO_CUSTOS_EMISSAO_NF', response.data.custosEmissãoNF);
    return response.data.informacoesProcesso[0];
  },
  async fetchProcessoEventoPreFaturamento({ commit }, payload) {
    const { codigoProcesso, codigoFilial } = payload;
    const response = await api.get(`/processo/conferencia/processo/${codigoProcesso}/filial/${codigoFilial}/possui-evento-conferencia-pre-faturamento`);
    commit('SET_PRE_FATURAMENTO_EXIBIR', response.data);
  },
};
